import { css } from 'glamor';

export default css({
  fontWeight: '500',
  lineHeight: 1.15,
  marginTop: 1,
}).toString();
